import { render, staticRenderFns } from "./DepartmentsField.vue?vue&type=template&id=5497f9bc&"
import script from "./DepartmentsField.vue?vue&type=script&lang=js&"
export * from "./DepartmentsField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports